// Vendor Libs
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {push} from 'react-router-redux';
import {get, omit} from 'lodash';

// Redux Actions
import * as formDataActions from '../actions/form-data-actions';

// Configs
import servicesFormConfig from '../../config/services-form-config';

export default function formHoc(WrappedComponent, formName) {
    class FormWrapper extends Component {
        getChildContext() {
            const {push, registerForm, resetForm, setFieldValues, setFormRequestPath, setFormSubmitted} = this.props;

            return {
                push,
                registerForm: () => registerForm(formName),
                resetForm: () => resetForm(formName),
                setFieldValues: values => setFieldValues(formName, values),
                setFormRequestPath: requestPath => setFormRequestPath(formName, requestPath),
                setFormSubmitted: (actionShouldFetch, submitted) =>
                    setFormSubmitted(actionShouldFetch, formName, formName, submitted),
            };
        }

        UNSAFE_componentWillMount() {
            this.props.registerForm(formName);
        }

        getProps() {
            const {routerParams, servicesSearchData} = this.props;

            return {
                ...omit(this.props, ['servicesSearchData']),
                formName,
                routerParams,
                searchFetching: get(servicesSearchData, 'fetching'),
                searchValues: get(servicesSearchData, 'searchData.content.0', {}),
                searchData: get(servicesSearchData, 'searchData', {}),
            };
        }

        render() {
            return <WrappedComponent {...this.getProps()} />;
        }
    }

    FormWrapper.propTypes = {
        formData: PropTypes.object,
        push: PropTypes.func.isRequired,
        registerForm: PropTypes.func.isRequired,
        resetForm: PropTypes.func.isRequired,
        routerParams: PropTypes.object.isRequired,
        servicesSearchData: PropTypes.object,
        setFieldValues: PropTypes.func.isRequired,
        setFormRequestPath: PropTypes.func.isRequired,
        setFormSubmitted: PropTypes.func.isRequired,
    };

    FormWrapper.childContextTypes = {
        push: PropTypes.func.isRequired,
        registerForm: PropTypes.func.isRequired,
        resetForm: PropTypes.func.isRequired,
        setFieldValues: PropTypes.func.isRequired,
        setFormRequestPath: PropTypes.func.isRequired,
        setFormSubmitted: PropTypes.func.isRequired,
    };

    function mapStateToProps(state) {
        return {
            formData: get(state.formData, [formName], {}),
            routerParams: get(state.servicesSearchData, 'routerParams', {}),
            servicesSearchData: get(
                state.servicesSearchData,
                [get(servicesFormConfig, [formName, 'dependentServicesDataKey'])],
                {}
            ),
        };
    }

    function mapDispatchToProps(dispatch) {
        return bindActionCreators({...formDataActions, push}, dispatch);
    }

    return connect(mapStateToProps, mapDispatchToProps)(FormWrapper);
}
